module.exports = __webpack_public_path__ + "img/Scaramucci.f59482ee.jpg";